import React, { useEffect, useRef, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import BetOption from "../../Components/AviatorComponent/BetOption";
import BetSection from "../../Components/AviatorComponent/BetSection";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import SocketHoc from "./SocketHoc";
import { useMediaQuery } from "react-responsive";
import { AviatorImages } from "../../ImageController/Index";
import { AviatorPlayHistory } from "./AviatorEndpoints";
import { getProfile } from "../Profile/UserEndpoints";
import { useCommmonStore } from "../../Store/CommonReducer";
const Main = ({ isFlying, waitingTime, setIsFlying }) => {
  const stateRef = useRef(null);
  const currentStage = waitingTime?.data?.gameStage;
  const flyingStatus = isFlying?.flewAwayCheck;
  const { profileDetail, setProfileDetail } = useCommmonStore();

  const [xval, setxval] = useState(0);
  const [yval, setyval] = useState(0);
  const [x, setX] = useState(0); // useState to store x
  const [inSmallCondition, setInSmallCondition] = useState(false);
  const [playhistory, setPlayHistory] = useState([]);
  const isExtraSmallScreen = useMediaQuery({ minWidth: 250, maxWidth: 500 });

  gsap.registerPlugin(useGSAP);

  const container = useRef();
  const fun = () => {
    gsap.to(".curveBg", {
      duration: currentStage === "waiting" ? 0 : 4,
      height: isExtraSmallScreen ? yval * 200 : xval * 400,
      width: isExtraSmallScreen ? xval * 200 : yval * 400,
    });
    gsap.to(".box", {
      duration: currentStage === "waiting" ? 0 : 4,
      ease: "expoScale(1,2,none)",
      y: isExtraSmallScreen ? -yval * 200 : -xval * 400,
      x: isExtraSmallScreen ? xval * 200 : yval * 400,
    });
  };

  useGSAP(
    () => {
      fun();
    },
    { scope: container, dependencies: [xval, yval] }
  ); // <-- scope for selector text (optional)
  const UserProfile = () => {
    getProfile()
      .then((res) => {
        if (res.status) {
          setProfileDetail(res.data);
        }
      })
      .catch((err) => console.log(err));
  };
  useEffect(() => {
    // GetRoomDetails();
    UserProfile();
  }, []);
  useEffect(() => {
    let interval;
    if (currentStage === "play" && flyingStatus === false) {
      interval = setInterval(() => {
        setX((prevX) => {
          const newX = isExtraSmallScreen ? prevX + 0.3 : prevX + 0.1;
          if (yval < 1.5 && !inSmallCondition) {
            setxval(newX);
            setyval((prevY) =>
              isExtraSmallScreen ? prevY + 0.5 : Math.pow(2, newX)
            );
          } else {
            clearInterval(interval);
          }
          return newX;
        });
      }, 1000);
    }
    return () => clearInterval(interval); // Cleanup interval on component unmount
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    yval,
    waitingTime,
    flyingStatus,
    currentStage,
    isExtraSmallScreen,
    inSmallCondition,
  ]);

  useEffect(() => {
    let timer;
    if (currentStage === "play" && flyingStatus === false) {
      if (yval >= 1.5) {
        const arr = [0.1, 0.6];
        timer = setInterval(() => {
          const randomIndex = Math.floor(Math.random() * arr.length);
          if (isExtraSmallScreen) {
            setyval(arr[randomIndex]);
            setInSmallCondition(true);
          } else {
            setxval(arr[randomIndex]);
          }
        }, 1000);
      }
    }

    return () => clearTimeout(timer);
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [xval, yval, waitingTime, flyingStatus, currentStage, isExtraSmallScreen]);

  useEffect(() => {
    fun();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [xval, yval]);

  useEffect(() => {
    const audio = new Audio("/aviatortune.mp3");
    audio.loop = true;
    audio.play().catch((error) => {
      console.log("Autoplay failed:", error);
    });
    AviatorPlayHistory()
      .then((res) => {
        if (res.success) {
          setPlayHistory(res.data);
        }
      })
      .catch((err) => console.log(err));
    UserProfile();
    return () => {
      audio.pause();
      audio.currentTime = 0;
    };
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let audio = new Audio("/airplane-whistle.mp3");

    if (currentStage === "waiting") {
      setIsFlying(null);
      setxval(0.0);
      setX(0);
      setyval(0.0);
      audio.pause();
      audio.currentTime = 0;
    } else if (currentStage === "play" && flyingStatus) {
      setxval(2);
      setyval(Math.pow(2, 2));
      audio.loop = true;
      audio.play().catch((error) => {
        console.log("Autoplay failed:", error);
      });
    } else if (currentStage === "play" && !flyingStatus) {
      setIsFlying(isFlying);
    }
    return () => {
      audio.pause();
      audio.currentTime = 0;
    };
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [waitingTime, isFlying, flyingStatus, currentStage]);

  useEffect(() => {
    setInSmallCondition(false);
  }, [isExtraSmallScreen]);

  return (
    <>
      <div className="grid grid-cols-9 gap-4  min-h-screen max-h-full h-full bg-black place-items-start p-2">
        <div className="col-span-3 hidden lg:block h-full w-full">
          <BetSection />
        </div>
        <div className="col-span-9 lg:col-span-6 w-full">
          <div className="flex justify-between w-full  items-center">
            <div className="flex justify-center w-[80%] md:w-[90%] overflow-x-scroll items-center gap-x-3">
              {playhistory.map((i, index) => {
                return (
                  <p
                    key={index}
                    className="text-[#00FFFF] bg-[#141516] text-xs px-3 py-1 rounded-full"
                  >
                    {i.flyRange ?? 0}x
                  </p>
                );
              })}
            </div>
            <div className="w-[20%] md:w-[10%] flex justify-end font-medium text-green-600">
              <p>₹ {profileDetail?.user?.wallet_balance ?? 0}</p>
            </div>
          </div>
          <div className="w-full border  border-[#1F2022] relative overflow-hidden  mt-2 h-[50vh] md:h-[60vh] rounded-lg bg-[#101112]">
            <img
              src={AviatorImages.gamebg}
              loading="lazy"
              className={`absolute    ${
                currentStage === "play" && !flyingStatus
                  ? "rotate"
                  : "scale-[105]"
              } top-[50%] md:top-[25%] lg:top-[30%] xl:top-[5%] 2xl:-top-[10%] -left-[52%] xl:-left-[52%] 2xl:-left-[50%] `}
            />
            <div className="flex absolute gap-x-6 bottom-4 left-[5%]  h-[5px]  w-[100%] overflow-hidden">
              {[1, 2, 3, 4].map((i, index) => (
                <LazyLoadImage
                  key={index}
                  src={AviatorImages.horDots}
                  className={`${
                    currentStage === "play" && !flyingStatus ? "hrdots" : ""
                  }`}
                />
              ))}
            </div>
            <div className="flex flex-col h-[100%] w-[5px]  overflow-hidden gap-y-10 absolute  left-[1%]  bottom-[5%]">
              {[1, 2].map((i, index) => (
                <LazyLoadImage
                  key={index}
                  src={AviatorImages.verDots}
                  className={`${
                    currentStage === "play" && !flyingStatus ? "vrdots" : ""
                  }`}
                />
              ))}
            </div>

            <div
              ref={container}
              className=" border  border-[#1F2022] w-full rounded-lg h-full relative left-[3%] bottom-[8%]"
            >
              <div>
                <LazyLoadImage
                  alt="plane"
                  loading="lazy"
                  src={AviatorImages.plane}
                  className="absolute  box bottom-0 w-28"
                />
                <div
                  className={`absolute curveBg bottom-0 left-0  bg-contain bg-no-repeat`}
                >
                  <LazyLoadImage
                    src={AviatorImages.curve}
                    style={{ height: "100%", width: "100%" }}
                    alt="curve"
                    className="opacity-75"
                  />
                </div>
                {currentStage === "waiting" && (
                  <div className="absolute  flex justify-center items-center flex-col top-1/4 left-[15%] md:left-[37%]">
                    <LazyLoadImage
                      src={AviatorImages.GameLoader}
                      className="w-10 md:w-20 animate-spin"
                      alt="gameloader"
                    />
                    <p className="uppercase mt-4 text-white font-bold font-cairo text-xl flex justify-center items-center">
                      Waiting for next round
                    </p>
                  </div>
                )}
                {currentStage === "play" && (
                  <div
                    className={`absolute  ${
                      flyingStatus && currentStage === "play" && "backgroundImg"
                    }  flex justify-center items-center flex-col top-1/4 left-[37%]`}
                  >
                    <p
                      className={` mt-4 ${
                        flyingStatus ? "text-[#770100]" : "text-white"
                      }  font-bold font-cairo text-2xl md:text-6xl flex justify-center items-center`}
                    >
                      {isFlying?.currentFlyRange ?? 0}x
                    </p>
                    {flyingStatus && currentStage === "play" && (
                      <p className="uppercase mt-4 text-white font-bold font-cairo text-2xl md:text-6xl flex justify-center items-center">
                        Flew Away
                      </p>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 mt-3 place-items-center gap-2">
            <BetOption isFlying={isFlying} waitingTime={waitingTime} />
            <BetOption isFlying={isFlying} waitingTime={waitingTime} />
          </div>
          <div className=" lg:hidden block mt-4 h-full w-full">
            <BetSection />
          </div>
        </div>
      </div>
    </>
  );
};

export default SocketHoc(Main);
